import { render, staticRenderFns } from "./RelatieHerinnering.vue?vue&type=template&id=211e58a9"
import script from "./RelatieHerinnering.vue?vue&type=script&lang=js"
export * from "./RelatieHerinnering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports